<template>
  <div class="card-info">
    <div v-if="showSwitch" class="form-group">
      <div class="card-info__switch">
        <div :class="['card-info__switch-item', { active: !isBusinessType }]" @click="switchType(false)">
          МПК / Подкомиссия / РГ
        </div>
        <div :class="['card-info__switch-item', { active: isBusinessType }]" @click="switchType(true)">ДС</div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group required">
          <ComponentInput
            label="Страна"
            :select2Settings="select2Settings"
            :select2Options="countryList"
            v-model="item.countryId"
            :disabled="isCountrySelectDisabled"
            type="select2"
            required
          />
        </div>
      </div>
      <div class="card-info__row-col">
        <div v-if="isBusinessType" class="form-group">
          <ComponentInput
            label="ДС"
            :select2Settings="select2SettingsSearchAll"
            :select2Options="businessAdviceList"
            v-model="item.mpkBusinessTipId"
            type="select2"
            placeholder="ДС"
            :disabled="isMpkDisabled"
          />
        </div>
        <div v-else class="form-group">
          <ComponentInput
            label="МПК / Подкомиссия / РГ"
            :select2Settings="select2SettingsSearchAll"
            :select2Options="mpkFilterList"
            v-model="item.mpkId"
            type="select2"
            placeholder="МПК / Подкомиссия / РГ"
            :disabled="isMpkDisabled"
          />
        </div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group required">
          <ComponentInput
            v-model="item.name"
            label="Название мероприятия"
            required
            maxLength="500"
            placeholder="Введите название"
          />
        </div>
      </div>
      <div class="card-info__row-col">
        <div class="form-group required">
          <ComponentInput
            label="Тип мероприятия"
            :select2Settings="select2Settings"
            :select2Options="getEventTypeList"
            v-model="item.eventTypeId"
            type="select2"
            required
          />
        </div>
      </div>
    </div>

    <div v-if="!isBusinessType" class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Включение проектов МПК</p>
          <SelectMultiComponentCheckbox
            placeholder="Выберите проект"
            :modelValue="item.mpkEventProjectsInclude"
            @update:modelValue="onUpdateMpkEventProjects($event, 'mpkEventProjectsInclude')"
            :options="mpkProjectsIncludeOptions"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
          />
        </div>
      </div>
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Исключение проектов МПК</p>
          <SelectMultiComponentCheckbox
            placeholder="Выберите проект"
            :modelValue="item.mpkEventProjectsExclude"
            @update:modelValue="onUpdateMpkEventProjects($event, 'mpkEventProjectsExclude')"
            :options="mpkProjectsExcludeOptions"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
          />
        </div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group">
          <ComponentInput v-model="item.place" label="Место проведения" maxLength="500" placeholder="Введите место" />
        </div>
        <div class="form-group-checkboxes">
          <div class="checkboxInput" v-for="t in eventConductTypeList" :key="t.id">
            <input
              type="checkbox"
              class="form-check-input"
              v-model="item.eventConductTypesIds"
              :value="t.id"
              :id="'eventConductType' + t.id"
            />
            <label :for="'eventConductType' + t.id" class="form-check-label form-label">{{ t.text }}</label>
          </div>
        </div>
      </div>
      <div class="card-info__row-col">
        <div class="form-group date">
          <p class="title-row">Дата и время проведения</p>
          <div class="date-container" v-for="(el, index) in item.eventDatesList" :key="index">
            <DateTimeComponent v-model="el.date" :typeable="true" />
            <IconComponent v-if="index == 0" @click="addEventDate()" name="plus_btn" />
          </div>
        </div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Состав документов</p>
          <div class="form-group-checkboxes">
            <div class="checkboxInput">
              <input type="checkbox" class="form-check-input" v-model="item.isDocProtokol" id="isDocProtokol" />
              <label for="isDocProtokol" class="form-check-label form-label">Протокол</label>
            </div>

            <div class="checkboxInput">
              <input type="checkbox" class="form-check-input" v-model="item.isDocPovestka" id="isDocPovestka" />
              <label for="isDocPovestka" class="form-check-label form-label">Повестка пленарного заседания</label>
            </div>

            <div class="checkboxInput">
              <input type="checkbox" class="form-check-input" v-model="item.isDocProject" id="isDocProject" />
              <label for="isDocProject" class="form-check-label form-label">Проект распоряжения</label>
            </div>
          </div>
        </div>
      </div>
      <div class="card-info__row-col"></div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Разрешение регистрации</p>
          <div class="form-group-checkboxes">
            <div class="checkboxInput">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="item.isRegistrationPermit"
                id="chbx_isRegistrationPermit"
              />
              <label for="chbx_isRegistrationPermit" class="form-check-label form-label">Регистрация разрешена</label>
            </div>
          </div>
        </div>
      </div>

      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Закрытие регистрации</p>
          <p class="form-label">Регистрация закрывается за</p>
          <div class="registration-close-row">
            <input
              type="text"
              class="registration-close-row__input"
              placeholder="Введите число"
              v-model="item.registrationCloseBeforeInDays"
            />
            <p class="form-label">дн.</p>
          </div>
          <div class="invalid-msg" v-if="v$.item.registrationCloseBeforeInDays.$error">Введите корректное число</div>
        </div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Публикация на портале</p>
          <div class="form-group-checkboxes">
            <div class="checkboxInput">
              <input type="checkbox" class="form-check-input" v-model="item.isPublish" id="chbx_isPublish" />
              <label for="chbx_isPublish" class="form-check-label form-label">опубликовать</label>
            </div>
          </div>
        </div>
      </div>
      <div class="card-info__row-col">
        <div class="form-group">
          <p class="title-row">Номер и дата распоряжения</p>
          <ComponentInput v-model="item.orderNumberDate" maxLength="500" placeholder="Введите номер и дату" />
        </div>
      </div>
    </div>

    <div class="card-info__row">
      <div class="card-info__row-col w-100">
        <p class="title-row">Ссылка на мероприятие</p>
        <a :href="publicUrl" target="_blank">{{ publicUrl }}</a>
      </div>
    </div>

    <div class="card-info__row btns">
      <ButtonComponent mod="gradient-bg" :disabled="isSaving" @click="save">{{ saveButtonText }}</ButtonComponent>
      <ButtonComponent mod="border" :disabled="isSaving" @click="cancel">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { numeric } from '@vuelidate/validators';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateTimeComponent from '@/common/components/DateTimeComponent.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';

  import AssignmentAPI from '@/modules/eap/api/assignment';
  import commissionAPI from '@/modules/mpk/api/commission';
  import API from '@/modules/mpk/api/event';
  import { ASSIGNMENT_OBJECT_TYPE_EVENT, EVENT_TYPE_CATEGORY_ID } from '@/modules/mpk/utils/constants';
  import { applyDisabledToOptions } from '@/modules/mpk/utils/selectOptions';
  import PROJECT_API from '@/modules/mpkProject/api/index';

  const MPK_EVENT_TYPE_CATEGORY_MPK = 1;

  export default {
    name: 'EventCardAddContent',
    components: {
      ComponentInput,
      ButtonComponent,
      DateTimeComponent,
      IconComponent,
      SelectMultiComponentCheckbox,
    },
    props: {
      showSwitch: {
        type: Boolean,
        default: false,
      },
      isCountryDisabled: {
        type: Boolean,
        default: false,
      },
      isMpkDisabled: {
        type: Boolean,
        default: false,
      },

      initialCountryId: {
        type: Number,
        default: null,
      },
      initialMpkId: {
        type: Number,
        default: null,
      },
      assignmentId: {
        type: Number,
        default: null,
      },
      defaultCountryId: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        item: {
          mpkId: null,
          countryId: null,
          eventTypeId: null,
          isActive: true,
          eventDatesList: [{ date: null }],
          eventConductTypesIds: [],
          uid: null,
          mpkBusinessTipId: null,
          mpkEventProjectsInclude: [],
          mpkEventProjectsExclude: [],
        },
        select2Settings: Constants.select2Settings,
        select2SettingsSearchAll: Constants.select2SettingsSearchAll,

        mpkList: [],
        mpkProjectsList: [],
        currentEventTypes: [],
        eventTypesMPK: [],
        eventTypesBA: [],
        countryList: [{ id: 0, text: Constants.emptySelectOptionText, selected: true }],
        eventConductTypeList: [],

        isBusinessType: false,
        businessAdviceList: [],

        isSaving: false,
      };
    },
    async created() {
      if (this.initialCountryId) {
        this.item.countryId = this.initialCountryId;
      }
      if (this.initialMpkId) {
        this.item.mpkId = this.initialMpkId;
      }
      if (this.defaultCountryId) {
        this.item.countryId = this.defaultCountryId;
      }

      await this.loadCard();
      await Utils.loadSelectOptions('countryList', this.countryList);
      await this.loadEventTypes();
      Utils.loadSelectOptions('mpkEventConductTypeList', this.eventConductTypeList);

      if (this.isMpkDisabled && this.item.countryId && this.initialMpkId) {
        await this.loadMpkForModal();
      }

      this.checkAssignmentFromRoute();
    },
    methods: {
      addEventDate() {
        this.item.eventDatesList.push({ date: null });
      },

      convertMpkProjectsIds(array) {
        return array.map((id) => ({ projectId: id }));
      },

      onUpdateMpkEventProjects(selectedIds, sourceKey) {
        const targetKey =
          sourceKey === 'mpkEventProjectsInclude' ? 'mpkEventProjectsExclude' : 'mpkEventProjectsInclude';
        const normalizedSelectedIds = new Set((selectedIds || []).map((selectedId) => String(selectedId)));

        this.item[sourceKey] = selectedIds;
        this.item[targetKey] = (this.item[targetKey] || []).filter(
          (selectedIdInTarget) => !normalizedSelectedIds.has(String(selectedIdInTarget)),
        );
      },

      async loadMpk() {
        this.mpkList = [];
        try {
          const response = await API.getMpkForEvent({
            countryId: this.item.countryId,
            isOnlyActive: true,
            mpkEventTypeCategoryId: MPK_EVENT_TYPE_CATEGORY_MPK, // Этот параметр просил воткнуть бэк, чтобы тянуть список только нужных мпк/рг/подкомиссий
          });
          this.mpkList = response.data ? response.data : [];
        } catch {
          this.mpkList = [];
        }
      },

      async loadMpkProjects(id) {
        try {
          const response = await PROJECT_API.search({ mpkComissionId: id });
          this.mpkProjectsList = response.data.items ? response.data.items : [];
        } catch {
          this.mpkProjectsList = [];
        }
      },

      async loadMpkForModal() {
        if (!this.initialMpkId) return;

        try {
          const response = await API.getMpkForEvent({
            countryId: this.item.countryId,
            isOnlyActive: true,
            mpkEventTypeCategoryId: 1,
          });

          if (response.data) {
            const currentCommission = response.data.find((x) => x.id === this.initialMpkId);
            if (currentCommission) {
              this.mpkList = [currentCommission];
            } else {
              await this.loadCurrentCommission();
            }
          }
        } catch (error) {
          await this.loadCurrentCommission();
        }
      },

      async loadCurrentCommission() {
        if (!this.initialMpkId) return;

        try {
          const response = await commissionAPI.find(this.initialMpkId);
          if (response.data) {
            this.mpkList = [
              {
                id: response.data.id,
                name: response.data.name,
                text: response.data.name,
              },
            ];
          }
        } catch (error) {
          Constants.alert.fire(Constants.errorTitle, Constants.commonError, 'error');
        }
      },

      async loadBusinesstips() {
        this.businessAdviceList = [];
        try {
          const response = await API.getBusinesstipsearch({ countryId: this.item.countryId, isOnlyActive: true });
          if (response.data && response.data.length) {
            this.businessAdviceList = response.data.map((businessAdviceItem) => ({
              ...businessAdviceItem,
              text: businessAdviceItem.name,
            }));
          }
        } catch {
          Constants.alert.fire(Constants.errorTitle, Constants.commonError, 'error');
        }
      },

      loadCard() {
        API.getUid().then((response) => {
          this.item.uid = response.data;
        });
      },

      async save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire(Constants.errorTitle, Constants.validationError, 'error');
          return;
        }

        this.isSaving = true;

        try {
          const itemToSave = Object.assign(
            {},
            {
              ...this.item,
              mpkEventProjectsInclude: this.convertMpkProjectsIds(this.item.mpkEventProjectsInclude),
              mpkEventProjectsExclude: this.convertMpkProjectsIds(this.item.mpkEventProjectsExclude),
            },
          );

          if (itemToSave.mpkId == 0) {
            itemToSave.mpkId = null;
          }
          if (itemToSave.mpkBusinessTipId == 0) {
            itemToSave.mpkBusinessTipId = null;
          }

          itemToSave.eventDatesList = this.item.eventDatesList
            .filter((eventDateItem) => eventDateItem.date != null)
            .map((eventDateItem) => eventDateItem.date);
          if (itemToSave.registrationCloseBeforeInDays == '') itemToSave.registrationCloseBeforeInDays = null;

          const response = await API.update(itemToSave);

          if (this.assignmentId) {
            try {
              const updateData = {
                id: this.assignmentId,
                eventId: response.data.id,
                eventTypeId: ASSIGNMENT_OBJECT_TYPE_EVENT,
              };

              await AssignmentAPI.update(updateData);
              Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            } catch (error) {
              Constants.alert.fire(Constants.errorTitle, 'Ошибка при обновлении поручения', 'error');
            }
          }

          if (response && response.data.id) {
            response.data.eventTypeName = this.currentEventTypes.find(
              (item) => item.id == response.data.eventTypeId,
            )?.text;
            this.$emit('saved', response.data);
          }
        } catch (error) {
          Constants.alert.fire('Сохранение', Constants.commonError, 'error');
        } finally {
          this.isSaving = false;
        }
      },

      cancel() {
        this.$emit('cancel');
      },

      loadEventTypes() {
        if (this.isBusinessType) {
          this.loadEventTypesBA();
        } else {
          this.loadEventTypesMPK();
        }
      },

      async loadEventTypesBA() {
        if (this.eventTypesBA.length > 0) {
          this.currentEventTypes = this.eventTypesBA;
        } else {
          await Utils.loadSelectOptions('mpkEventTypeList', this.eventTypesBA, {
            categoryId: EVENT_TYPE_CATEGORY_ID.BUSINESS_ADVICE,
          });
          this.currentEventTypes = this.eventTypesBA;
        }
      },

      async loadEventTypesMPK() {
        if (this.eventTypesMPK.length > 0) {
          this.currentEventTypes = this.eventTypesMPK;
        } else {
          await Utils.loadSelectOptions('mpkEventTypeList', this.eventTypesMPK, {
            categoryId: EVENT_TYPE_CATEGORY_ID.MPK_SC_RG,
          });
          this.currentEventTypes = this.eventTypesMPK;
        }
      },

      checkAssignmentFromRoute() {
        if (this.$route.query && this.$route.query.assignmentId) {
          if (this.$route.query.assignmentCountryId) {
            this.item.countryId = Number(this.$route.query.assignmentCountryId);
          }
        }
      },

      switchType(state) {
        this.item.eventTypeId = null;
        if (!this.assignmentId) {
          this.item.countryId = null;
        }
        this.item.mpkBusinessTipId = null;
        this.item.mpkId = null;
        this.isBusinessType = state;
        this.mpkList = [];
        this.businessAdviceList = [];
        this.loadEventTypes();
      },
    },
    computed: {
      mpkFilterList() {
        var list = [{ id: 0, text: Constants.emptySelectOptionText, selected: true }];
        this.mpkList
          .map((mpkItem) => ({ id: mpkItem.id, text: mpkItem.name }))
          .forEach(function (el) {
            list.push(el);
          });

        return list;
      },

      mpkProjectsFilterList() {
        return this.mpkProjectsList.map((item) => ({ id: item.id, text: item.name }));
      },
      mpkProjectsIncludeOptions() {
        return applyDisabledToOptions(this.mpkProjectsFilterList, this.item.mpkEventProjectsExclude);
      },
      mpkProjectsExcludeOptions() {
        return applyDisabledToOptions(this.mpkProjectsFilterList, this.item.mpkEventProjectsInclude);
      },
      publicUrl() {
        return Utils.getPublicBaseUrl() + 'events/' + this.item.uid;
      },

      getEventTypeList() {
        return this.currentEventTypes;
      },

      saveButtonText() {
        return this.isSaving ? 'Сохранение...' : 'Сохранить';
      },

      isCountrySelectDisabled() {
        return this.item.mpkId > 0 || this.defaultCountryId > 0 || !!this.assignmentId || this.isCountryDisabled;
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {
          registrationCloseBeforeInDays: { numeric },
        },
      };
    },
    watch: {
      'item.countryId': {
        async handler(newCountryId) {
          if (!this.item.countryId) {
            this.businessAdviceList = [];
            this.mpkList = [];
          }

          if (!this.assignmentId && !this.isMpkDisabled) {
            this.item.mpkBusinessTipId = null;
            this.item.mpkId = null;
          }

          if (!newCountryId || newCountryId <= 0) {
            return;
          }

          if (this.isBusinessType) {
            await this.loadBusinesstips();
          } else if (!this.isMpkDisabled) {
            await this.loadMpk();
          }
        },
        immediate: false,
      },
      'item.mpkId': {
        async handler(newMpkId) {
          if (!newMpkId) {
            this.mpkProjectsList = [];
            this.item.mpkEventProjectsInclude = [];
            this.item.mpkEventProjectsExclude = [];

            return;
          }

          await this.loadMpkProjects(newMpkId);
        },
      },
    },
  };
</script>

<style lang="scss">
  .date {
    &-container {
      margin-bottom: 16px;
      .v3dp__datepicker,
      .input-group-wrapper {
        margin-right: 8px;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .form {
    &-label {
      font-weight: 400 !important;
      font-size: 14px;
      color: #231f20;
      line-height: 160%;
    }
    &-group-checkboxes {
      display: flex;
      flex-wrap: wrap;
      .checkboxInput {
        &:not(:last-of-type) {
          margin-right: 34px;
          margin-bottom: 34px;
        }
      }
      .form-check-input {
        left: 30px;
        top: 10px;
      }
    }
  }
  .date {
    &-container {
      display: flex;
      align-items: center;
    }
  }
  .title-row {
    margin-bottom: 8px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 400;
  }
  .registration-close-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .card-info {
    &__row {
      justify-content: space-between;
      flex-wrap: wrap;
      &:nth-of-type(5) {
        .card-info__row-col {
          &:nth-of-type(2) {
            .form-group-container {
              display: flex;
              align-items: center;
              justify-content: space-between;
              p {
                font-weight: 400 !important;
                font-size: 14px;
                color: #231f20;
                line-height: 160%;
              }
              input {
                max-width: 220px;
                width: 100%;
              }
            }
          }
        }
      }
      &.btns {
        button {
          max-width: 221px;
          width: 100%;
        }
      }
    }

    &__switch {
      border-radius: 4px;
      background: $grey;
      display: inline-flex;
      padding: 4px;
      margin-bottom: 16px;

      &-item {
        border-radius: 3px;
        background: transparent;
        transition: 0.3s ease;
        font: 500 15px / 15px 'Fira Sans';
        letter-spacing: -0.3px;
        color: $blue;
        padding: 8px 16px;
        cursor: pointer;

        &.active {
          background: #fff;
        }
      }
    }

    &__row-col {
      width: calc(50% - 16px);

      .form-group {
        width: 100%;

        &:not(:last-child) {
          margin-bottom: 16px;
        }
      }
    }
  }

  .w-100 {
    width: 100% !important;
  }

  @media (max-width: 768px) {
    .card-info {
      &__row-col {
        width: 100%;
      }

      &__row.btns {
        button {
          max-width: unset;
          margin-bottom: 16px;
        }
      }
    }
  }

  :deep(.select2-container--disabled .select2-selection) {
    background-color: #ececec !important;
    cursor: not-allowed !important;
  }

  :deep(.select2-container--disabled .select2-selection__arrow) {
    display: none !important;
  }
</style>
